import { createRequest, HttpMethod, showError } from 'ehs-react';
import { PortletStoreApi } from '../App';

interface RequestResetPasswordParam {
  email: string;
}

/**
 * An AJAX call request reset password.
 */
const callForRequestResetPassword = createRequest<
  RequestResetPasswordParam,
  void
>({
  operation: 'requestResetPassword',
  method: HttpMethod.POST,
  returnsArray: false
});

/**
 *  Function to request reset password.
 * @param email of the user that wants to change the password.
 * @param onSuccess the call after successful request, should set next page.
 */
export const requestResetPassword = (
  email: RequestResetPasswordParam['email'],
  onSuccess: () => void
): void => {
  callForRequestResetPassword({
    url: PortletStoreApi.getState().url,
    email
  })
    .then(onSuccess)
    .catch(showError);
};
